import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'

const AdvisorViewItem = ({ children, xs }) => {
  return (
    <Grid className='__item' item xs={xs}>
      {children}
    </Grid>
  )
}

AdvisorViewItem.propTypes = {
  xs: PropTypes.number,
  children: PropTypes.node
}

AdvisorViewItem.defaultProps = {
  xs: 12
}

export default AdvisorViewItem
